

import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'







const BASE_URL = "https://cg.focuslight.net";
const H5_URL = "https://cg.focuslight.net";
const UPLOAD_URL = "https://cg.focuslight.net";
const IMAGE_URL = "http://cgfile.focuslight.net/group1";
const TX_ID_URL = "https://etherscan.io/tx/";
const SUFFIX = "shtml";
const SUCCESS_CODE = "100000";
const ERROR_CODE = "200000";
const INPUT_CODE = "000000";
const LOGIN_CODE = "300000";
const FUNCTION_CODE = "400000";

const fundTypeList = ["代理套餐手续费提成","业务员套餐手续费提成","代理卡片提额手续费","业务员卡片提额手续费"];
const fundModeList = ["进账","出账"];
const planStatusList = ["待处理","处理中","已完成"];
const sex = ["男","女"];

export default {
components: {
TransferDom, Group,Toast,Loading
},
data () {
return {
}
},
methods: {
submitFormAjax: function(

that,
gourl,
dataParameter,
loading_message,
callfn,
isLoading
) {
var gthat = this;
if(isLoading){//显示加载
that.$vux.loading.show({text: loading_message})
}



var qs = require("qs");


var liphone_vue = that.$storage.getStorage("liphone_trace_element");
var pwd_vue = that.$storage.getStorage("pwd_trace_element");

if(liphone_vue!=null && pwd_vue!=null) {
dataParameter.f_acc = liphone_vue;
dataParameter.f_acc_area = "86";
dataParameter.f_pwd = pwd_vue;
}



if(LOVER_DEBUG){
console.info("post:-->"+gourl)
console.info(dataParameter);
}
var localeLan = that.$locale.get();
if(localeLan){
dataParameter.global_language = localeLan;
}



that.$ajax({
method: "post",
url: BASE_URL + gourl + "." + SUFFIX,
data: qs.stringify(dataParameter)
})
.then(function(response) {
if(LOVER_DEBUG) {
console.info(response.data);
}

that.$vux.loading.hide();

if(response.data.code == LOGIN_CODE){//需要登录

that.$router.replace("/login");
}else if(response.data.code == FUNCTION_CODE){//没有权限

gthat.showToast(that,response.data.message,0);
}else if (response.data.code == ERROR_CODE || response.data.code == INPUT_CODE) {

gthat.showToast(that,response.data.message,0);
} else if (response.data.code == SUCCESS_CODE) {
if (typeof callfn === "function") {

callfn(response.data);
} else {
if(callfn=="" || callfn==undefined){

gthat.showToast(that,response.data.message,1);
that.$router ? that.$router.back() : window.history.back()
}else{

that.$router.push(callfn);
}
}
}
})
.catch(function(error) {
console.info(error);

if(isLoading){//显示加载
that.$vux.loading.hide();
}
});
},
submitFormAjaxSyn: function(

that,
gourl,
dataParameter,
loading_message,
callfn,
isLoading
) {
if(!syn_sub){
return;
}
syn_sub = false;
var gthat = this;
if(isLoading){//显示加载
that.$vux.loading.show({text: loading_message})
}



var qs = require("qs");


if(LOVER_DEBUG) {
console.info("post:-->" + gourl)
console.info(dataParameter);
}
var localeLan = that.$locale.get();
if(localeLan){
dataParameter.global_language = localeLan;
}


that.$ajax({
method: "post",
url: BASE_URL + gourl + "." + SUFFIX,
data: qs.stringify(dataParameter)
})
.then(function(response) {
syn_sub = true;
if(LOVER_DEBUG) {
console.info(response.data);
}

that.$vux.loading.hide();

if(response.data.code == LOGIN_CODE){//需要登录

that.$router.replace("/login");
}else if(response.data.code == FUNCTION_CODE){//没有权限

gthat.showToast(that,response.data.message,0);
}else if (response.data.code == ERROR_CODE || response.data.code == INPUT_CODE) {

gthat.showToast(that,response.data.message,0);
} else if (response.data.code == SUCCESS_CODE) {
if (typeof callfn === "function") {

callfn(response.data);
} else {
if(callfn=="" || callfn==undefined){

gthat.showToast(that,response.data.message,1);
that.$router ? that.$router.back() : window.history.back()
}else{

that.$router.push(callfn);
}
}
}
})
.catch(function(error) {
console.info(error);

if(isLoading){//显示加载
that.$vux.loading.hide();
}
});
},
sLoading(that,text,timeSp){
that.$vux.loading.show({
text: text
})
setTimeout(() => {
that.$vux.loading.hide()
}, timeSp)
},

deactivated() {
this.$vux.loading.hide();
},
getBodyHeight(){
return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
},
goBack(that){
that.$router ? that.$router.back() : window.history.back()
},
getTxIdUrl(){
return TX_ID_URL;
},
getImageUrl() {
return IMAGE_URL;
},
getBaseUrl() {
return BASE_URL;
},
getH5Url() {
return H5_URL;
},
getSuffix() {
return SUFFIX;
},
getUploadUrl() {
return UPLOAD_URL;
},
getFundTypeList(index){
return fundTypeList[index];
},
getFundModeList(index){
return fundModeList[index];
},
getSex(index){
return sex[index];
},
getPlanStatusList(index){
return planStatusList[index];
},
getUserInfo(that){//获取用户信息
var v_luser_str = that.$storage.getStorage("luser_trace_element");
if(v_luser_str!=null){
return JSON.parse(v_luser_str);
}
return null;
},
getCoinNameByCode(code){
var codeIF = code.toLowerCase();
if(codeIF=='shb'){
return "炬光宝";
}else if(codeIF=='zhye'){
return "余额";
}
},

getAuditString(that){
if(this.getUserInfo(that)!=null){
var ati = this.getUserInfo(that);
if(ati){
if(ati.card_auth_status==0){//未认证
return "立即认证";
}else if(ati.card_auth_status==1){//已认证
return "已认证";
}else if(ati.card_auth_status==2){//认证失败
return "重新认证";
}else{//审核中
return "审核中";
}
}
}
return "立即认证";
},

getAuditInfo(that){
var ati = this.getUserInfo(that).sysAccUserInfoYb;
return ati;
},

getAuditSex(that){
var ati = this.getUserInfo(that).sysAccUserInfoYb;
if(ati){
if(ati.sex==0){//男
return "男";
}else{//女
return "女";
}
}
return "";
},
getUrlKey:function(name){
return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
},
getUrlKeyPath:function(name,path){
return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(path)||[,""])[1].replace(/\+/g,'%20'))||null;
},

showToast(that,message,index){
var type="text";
if(index==0){
type="warn";
}else if(index==1){
type="success";
}
that.$vux.toast.show({
text: message,
type:type,
width:"auto",
time:"1500",

position:"top",
onShow () {},
onHide () {}
})
},

showAlert(that,title,content,callfn){
that.$vux.alert.show({
title: title,
content: content,
onShow () {},
onHide () {
if (typeof callfn === "function") {
callfn();
}
}
})
},
getContactTel(that,callfn){
that.GLOBAL.methods.submitFormAjax(that,"/app/contact",{},"",
function (json) {
if (typeof callfn === "function") {

callfn(json.data);
} else {
}
},
false
);
},
resetUserLocal(that,callfn){//重置用户信息
that.GLOBAL.methods.submitFormAjax(that,"/user/read",{},"",
function (json) {

that.$storage.setStorage("luser_trace_element", JSON.stringify(json.data));
if (typeof callfn === "function") {

callfn(json.data);
} else {
}
},
false
);
},
getParams(that,param_code,rType,callfn){//获取配置信息
that.GLOBAL.methods.submitFormAjax(that,"/app/params",{param_code:param_code,rType:rType},"",
function (json) {
if (typeof callfn === "function") {

callfn(json.data);
} else {
}
},
false
);
},
resetHisRecord(that,keywords){//设置本地搜索信息
var pArray = [];
if(keywords==""){
that.$storage.setStorage("luser_his_record", pArray);
return;
}
var luser_his_record = that.$storage.getStorage("luser_his_record");
if(luser_his_record!=null && luser_his_record.length>0){
pArray=luser_his_record;
}
pArray.push(keywords);
const res = new Map();
pArray=pArray.filter((a) => !res.has(a) && res.set(a, 1))
that.$storage.setStorage("luser_his_record", pArray);
},
getHisRecord(that){//获取本地搜索信息
return that.$storage.getStorage("luser_his_record")==null?[]:that.$storage.getStorage("luser_his_record");
},
getMtypeList(flag){
var mType = [];
if(flag){//goods list




}else{//index
mType.push({id:"2",type:true,name:"手机数码",img:require("@/assets/type/daohang/shoujishuma.png"),path:"/userb/ggoods?tid=476",click:true});
mType.push({id:"3",type:true,name:"中外名酒",img:require("@/assets/type/daohang/zhongwaimingjiu.png"),path:"/userb/ggoods?tid=418",click:true});
mType.push({id:"8",type:true,name:"果汁饮料",img:require("@/assets/type/daohang/guozhiyinliao.png"),path:"/userb/ggoods?tid=511",click:true});
mType.push({id:"-2",type:true,name:"精选茗茶",img:require("@/assets/type/daohang/jingxuanmingcha.png"),path:"/userb/ggoods?tid=434",click:true});
mType.push({id:"4",type:true,name:"炬光商品",img:require("@/assets/type/daohang/libaozhongxin.png"),path:"/userb/ggoods?tg=0",click:true});
mType.push({id:"1",type:true,name:"直售商品",img:require("@/assets/type/daohang/jiayongdianqi.png"),path:"/userb/ggoods?tg=1",click:true});
mType.push({id:"5",type:true,name:"积分商城",img:require("@/assets/type/daohang/jifenshangcheng.png"),path:"/userb/ggoods?tg=2",click:true});
mType.push({id:"6",type:true,name:"炬光宝",img:require("@/assets/type/daohang/zhibozhongxin.png"),path:"",click:false});

}
return mType;
},
openTTS(text){
if(isAndroid && isLover!=null){
openTTSJs(text);
}
},
dateZSif(ifdate){//日期判断
const end = new Date();
const start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
if(ifdate>=start.getTime() && ifdate<=end.getTime()){//在这里
return true;
}else{
return false;
}


},
goToShop(that,shop_id){//去店铺页面
that.$router.push({name: 'shopindex', params: { "refush": true, "shop_id": shop_id}});
},
}
};



// WEBPACK FOOTER //
// ./src/components/common/global.vue